import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import "./CompareProducts.scss";

export default function CompareProducts({ data, customData, action, isPermProductAvailable }) {
  const {title, description, products} = !customData ? data : customData;
  const navigate = useNavigate();

  const setButtonText = (item) => {
    if (item.action.type === "submit" || isPermProductAvailable) {
      return item.buttonText;
    } else {
      return "Contact a Specialist";
    }
  };

  const handleRedirect = (location) => {
    if (isPermProductAvailable) {
      // (window.location.href) is a temporary solution and should be refactored to use navigate(location) in the future for proper SPA routing.
      window.location.href = location;
    } else {
      navigate("/select-appointment");
    }
    window.scroll(0, 0);
  }

  return (
    <div className="compare-products-wrapper">
      <Container>
        <div className="compare-products-container">
          <h2>{title}</h2>
          <p>{description}</p>
          <div className="compare-products-card-container">
            <ul>
              {products.map((item, index) => {
                return <ProductCard key={(`productCard${index}`)}
                  productName={item.productName} 
                  description={item.description} 
                  buttonText={setButtonText(item)}
                  handleRedirect={handleRedirect}
                  isPermProductAvailable={isPermProductAvailable}
                  actionData={item.action}
                  action={action}/>
              })}
            </ul>
          </div>
        </div>
      </Container>
    </div>
  );
}

export function ProductCard(props) {
  const {productName, description, buttonText, isPermProductAvailable, actionData, action} = props;

  actionData.action = action;

  return (
    <li className="product-card">
      <p><span>{productName}</span> {description}</p>
      <Button 
        onClick={actionData.type === "redirect" ? () => props.handleRedirect(actionData.location) : action} 
        className="buttonStyles" 
        variant="contained">
        {buttonText}
      </Button>
    </li>
  );
}

CompareProducts.propTypes = {
  data: PropTypes.object.isRequired,
  customData: PropTypes.object,
}

ProductCard.propTypes = {
  productName: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
}
